export default __webpack_public_path__ + "static/media/nigeria-s-oil-curse-could-become-an-opportunity-for-renewable-power-2.796bcc4b.jpg";